<template>
  <div class="driver-wallet-view">
    <DriverWallet :driverID="id" />
  </div>
</template>


<script>
import DriverWallet from "@/components/DriverWallet.vue";

export default {
  name: "DriverWalletView",
  components: {
    DriverWallet,
  },
  props: {
    id: String,
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {
    if (!this.isSuperUser()) this.goHome(); // superuser only
    console.log("driverID", this.id);
  },
  methods: {},
};
</script>

<style scoped>
</style>